import { useHasDeferredIncomes } from "modules/finances/_shared";
import { Sidebar, WithSidebarContainer } from "modules/layout";
import { useMyPermissions } from "modules/my-permissions";
import { useRouter } from "next/router";
import pages from "pages/_router";
import React, { CSSProperties } from "react";
import { CompanyLayout } from "../_layout";

export interface ICompanyFinancesLayout {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
  fullWidth?: boolean;
}

export const CompanyFinancesLayout = (props: ICompanyFinancesLayout) => {
  const { query } = useRouter();
  const companySlug = query.company as string;

  const permissions = useMyPermissions(companySlug);

  const hasDeferred = useHasDeferredIncomes(companySlug);

  const mainHref = pages.company(companySlug).finances.href;

  return (
    <CompanyLayout title="Финансы" className={props.className} style={props.style} htmlId={props.htmlId}>
      <WithSidebarContainer
        mainHref={mainHref}
        fullWidth={props.fullWidth}
        sidebar={
          <Sidebar
            mainHref={mainHref}
            key={companySlug}
            menu={[
              {
                menu: [
                  permissions?.finances.budgets.read && {
                    label: "Месячные бюджеты",
                    href: pages.company(companySlug).finances.href,
                    exact: true,
                    additionalHref: pages.company(companySlug).finances.plan.href,
                  },
                  permissions?.finances.budgets.read && {
                    label: "Заявки на расход",
                    href: pages.company(companySlug).finances.fundingRequests.href,
                  },
                  !permissions?.finances.budgets.read && {
                    label: "Заявки на расход",
                    href: pages.company(companySlug).finances.href,
                    exact: true,
                    additionalHref: pages.company(companySlug).finances.fundingRequests.href,
                  },
                  permissions?.finances.budgets.read && {
                    label: "Фонды и счета",
                    href: pages.company(companySlug).finances.funds.href,
                  },
                  permissions?.finances.budgets.read && {
                    label: "Движение средств",
                    href: pages.company(companySlug).finances.reports.cashFlow.href,
                  },

                  permissions?.finances.fundingRequests.pay && {
                    label: "Выплаты",
                    href: pages.company(companySlug).finances.payouts.href,
                  },
                  permissions?.finances.budgets.read && {
                    label: "Займы",
                    href: pages.company(companySlug).finances.loans.href,
                  },
                  permissions?.finances.budgets.read &&
                    hasDeferred && {
                      label: "Отложенный доход",
                      href: pages.company(companySlug).finances.deferredIncomes.href,
                    },
                  permissions?.finances.budgets.read && {
                    label: "Обучение",
                    href: pages.company(companySlug).finances.education.tableOfContent.href,
                  },
                  { label: "Настройки", href: pages.company(companySlug).finances.settings.href },
                ],
              },
            ]}
          />
        }
      >
        {props.children}
      </WithSidebarContainer>
    </CompanyLayout>
  );
};
